export interface Search {
    searchQuery: string,
    selectedClient: SelectedClient | null,
    selectedRegion: SelectedRegion | null,
    searchType: SearchType,
}

export const compareSearch = (searchA: Search, searchB: Search): boolean => {
    const compareQuery = searchA.searchQuery === searchB.searchQuery;
    const compareClient = searchA.selectedClient?.id === searchB.selectedClient?.id;
    const compareRegion = searchA.selectedRegion?.id === searchB.selectedRegion?.id;
    const compareSearchType = searchA.searchType === searchB.searchType;

    return compareQuery && compareClient && compareRegion && compareSearchType;
};

export interface SortField {
    order: string
}

export interface SelectedClient {
    name: string,
    id: number
}

export interface SelectedRegion {
    name: string,
    id: number
}


export interface SearchResult<T> {
    score: number,
    source: T,
    highlight: Record<string, string>,
}

export interface LiveUnitSearchData {
    type: SearchSourceType.LiveUnit,
    id: number
    name: string,
    serial: string,
    client_id: number,
    client_name: string,
    date_activated?: string;
    date_deactivated?: string;
    latitude?: number,
    longitude?: number,
    location_name?: string,
    location_city?: string,
    location_street?: string,
    location_state?: string,
    location_country?: string,
    location_zip?: string,
    cameras: number[],
    primary_camera?: number,
    mounting_structure?: string;
    region_name?: string;
}

export interface ClientSearchData {
    type: SearchSourceType.Client,
    id: number,
    name: string
}

export interface RegionSearchData {
    type: SearchSourceType.Region,
    id: number,
    name: string
    client_name: string
}

export interface ArchiveCabinetSearchData {
    type: SearchSourceType.ArchiveCabinet,
    id: number
    name: string,
    client_id: number,
    client_name: number,
    latitude?: number,
    longitude?: number,
    location_name?: string,
    region_name?: string,
}

export enum SearchIndex {
    ArchiveCabinets = "archive_cabinets",
    LiveUnits = "live_units",
    Clients = "clients",
    Regions = "regions",
}

export enum SearchType {
    Default,
    Clients,
    Regions
}

export enum SearchSourceType {
    ArchiveCabinet = "archive_cabinet",
    Client = "client",
    LiveUnit = "live_unit",
    Region = "region",
}

export type ResultTypes = LiveUnitSearchData | ArchiveCabinetSearchData | ClientSearchData | RegionSearchData;

export const defaultSearch: Search = {
    searchQuery: "",
    selectedClient: null,
    selectedRegion: null,
    searchType: SearchType.Default,
};
